import * as React from 'react';
import Svg, {Path, G, Defs, ClipPath} from 'react-native-svg';

interface RewardsFocussedIconProps {
  fill?: string;
}

const NewRewardsIconFilled: React.FC<RewardsFocussedIconProps> = ({
  fill = '#3070ED',
}) => (
  <Svg width={35} height={34} viewBox="0 0 35 34" fill="none">
    <G clipPath="url(#clip0_16833_745)">
      <Path
        d="M16.276 6.255A4.583 4.583 0 0012.331 4h-.112a4.469 4.469 0 00-3.981 6.5h-1.3A2.438 2.438 0 004.5 12.938v3.25c0 1.06.68 1.965 1.625 2.3v8.262A3.253 3.253 0 009.375 30h16.25a3.253 3.253 0 003.25-3.25v-8.262a2.444 2.444 0 001.625-2.3v-3.25a2.438 2.438 0 00-2.438-2.438h-1.3A4.469 4.469 0 0022.782 4h-.111c-1.62 0-3.123.858-3.946 2.255L17.5 8.342 16.276 6.26v-.005z"
        fill={fill}
      />

      <Path d="M6.938 13h21.125v13H6.938V13Z" fill={fill} />

      <Path
        d="M13.5 9c-1 0-2.5-1-2.5-2s1-2 2-2 2 1 2 2c0 1-1 2-1.5 2Zm8 0c-1 0-2.5-1-2.5-2s1-2 2-2 2 1 2 2c0 1-1 2-1.5 2Z"
        fill={fill}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_16833_745">
        <Path fill="#fff" transform="translate(4.5 4)" d="M0 0H26V26H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default NewRewardsIconFilled;
